import { type Tax } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { TaxService } from "~Shared/services"
import { type ThunkResult } from "~Shared/store"
import { type FetchAllTaxesAction, TaxTypes, type UpdateAllTaxesAction } from "~Shared/store/actions/tax/taxTypes"
import { type CancelFetchAction, FetcherActionTypes } from "../fetcher/fetcherTypes"

export const fetchAllTaxes: ActionCreator<ThunkResult<Array<Tax>>> = () => async (dispatch: Dispatch) => {
    const taxes = await TaxService.fetchTaxes()
    const cancelFetchAction: CancelFetchAction = {
        type: FetcherActionTypes.CANCEL_FETCH,
        isFetchCancelled: true,
    }

    dispatch(cancelFetchAction)

    const fetchAllTaxes: FetchAllTaxesAction = {
        type: TaxTypes.FETCH_ALL_TAXES,
        taxes,
    }

    dispatch(fetchAllTaxes)
    return taxes
}

export const updateTaxes = (updatedTaxes: Array<Tax>) => async (dispatch: Dispatch) => {
    const taxes = await TaxService.updateAllTaxes(updatedTaxes)
    const updateAllTaxesAction: UpdateAllTaxesAction = {
        type: TaxTypes.UPDATE_ALL_TAXES,
        taxes,
    }

    dispatch(updateAllTaxesAction)
    return taxes
}
